import { reactToCwp } from '../../common/react-utils'
import CIHeader from './CIHeader'

export default reactToCwp(CIHeader)
